import {
  applyContextOptions,
  forceRestoreContextOptions,
  restoreContextOptions,
} from "@gameApp/helpers/canvas/contextOptions";
import {
  applyTranslate,
  restoreTranslate,
} from "@gameApp/helpers/canvas/translate";
import { getDevicePixelRatio } from "@gameApp/utils/getDevicePixelRatio";
import type { Options } from "@gameComponents/MiniGame/Charts/types";
import { line } from "d3";

export function miniGameChatsDrawLayer(
  options: Options,
  context: CanvasRenderingContext2D,
): void {
  const { xScale, yScale, dates, data } = options;

  const lineGenerator = line<number>()
    .x((_, i) => xScale(dates[i]))
    .y((d) => yScale(d))
    .context(context);

  applyContextOptions({
    context,
    contextOptions: {
      modify: (ctx) => {
        ctx.scale(getDevicePixelRatio(), getDevicePixelRatio());
      },
    },
  });

  applyTranslate({ ...options, context });
  applyContextOptions({ ...options, context });
  context.beginPath();
  lineGenerator(data);
  context.stroke();
  context.closePath();
  restoreContextOptions({ ...options, context });
  restoreTranslate({ ...options, context });
  forceRestoreContextOptions(context);
}
